module.exports = __webpack_public_path__ + "img/icon-light.d8405e64.png";